import { Injectable } from "@angular/core";
import { HandlerService } from "../comunicator-native/handler/handler";
import { DataOrigin } from "../../model/DataOrigin";
import { CpfDataService } from "./cpf-data.service";
import { CpfMockService } from "./cpf-data-mock.service";
import { CpfDataMobileService } from "./cpf-data-mobile.service";

@Injectable({
  providedIn: "root",
})
export abstract class CpfFactoryService {
  private services = new Map<DataOrigin, CpfDataService>();

  constructor(
    private handlerService: HandlerService
  ) {}

  public getService(origin: DataOrigin) {
    if (this.services.has(origin)) {
      return this.services.get(origin);
    } else {
      return this.constructService(origin);
    }
  }

  private constructService(origin: DataOrigin): CpfDataService {
    switch (origin) {
      case DataOrigin.Mobile:
        const serviceUserMobile = new CpfDataMobileService(this.handlerService);
        this.services.set(origin, serviceUserMobile);
        return serviceUserMobile;
      case DataOrigin.Mock:
        const serviceMock = new CpfMockService();
        this.services.set(origin, serviceMock);
        return serviceMock;
      default:
        const serviceDefault = new CpfMockService();
        this.services.set(origin, serviceDefault);
        return serviceDefault;
    }
  }
}
